import FJCarousel from '../../../common/components/FJCarousel/FJCarousel';
import styles from './FJMobileImageToImagePreset.module.less';
import { MOBILE_PREVIEW_DATA } from '../../../config/dataConfig/FJImageToImageData';

const FJMobileImageToImagePreset = () => {
    return (
        <div className={styles.inner}>
            <FJCarousel className={styles.carousel} items={MOBILE_PREVIEW_DATA} />
        </div>
    );
};

export default FJMobileImageToImagePreset;
